var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63943",
    "data-name": "Rectangle 63943",
    width: 17.342,
    height: 20,
    fill: "none",
    stroke: "#44546f",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48644",
    "data-name": "Group 48644",
    transform: "translate(-1191 -675)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138035",
    "data-name": "Rectangle 138035",
    width: 24,
    height: 24,
    transform: "translate(1191 675)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48645",
    "data-name": "Group 48645",
    transform: "translate(1194 677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44595",
    "data-name": "Group 44595",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_379",
    "data-name": "Ellipse 379",
    cx: 4.167,
    cy: 4.167,
    r: 4.167,
    transform: "translate(4.504 0.833)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89227",
    "data-name": "Path 89227",
    d: "M15.168,35.5H4.508a2.5,2.5,0,0,1-1.97-4.049A9.1,9.1,0,0,1,9.838,28a9.1,9.1,0,0,1,7.3,3.451A2.5,2.5,0,0,1,15.168,35.5Z",
    transform: "translate(-1.167 -16.333)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName01);
export default __webpack_public_path__ + "static/media/name01.9143c4e5a4d2b704e7421e6d0589e628.svg";
export { ForwardRef as ReactComponent };